import _taggedTemplateLiteral from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
var PathText = styled.path(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.palette.label.primary;
});

var FinamIcon = function FinamIcon() {
  return _jsxs("svg", Object.assign({
    width: "80",
    height: "24",
    viewBox: "0 0 80 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: [_jsx("rect", {
      width: "80",
      height: "24"
    }), _jsx(PathText, {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M39.2706 15.838C39.9082 15.1598 40.2354 14.2176 40.2354 13.0108C40.2354 10.3635 38.8774 8.8465 36.522 8.8465L35.2129 8.84526V8.07495H33.0212V8.84526L31.713 8.8465C29.3577 8.8465 28 10.3635 28 13.0108C28 15.4412 29.3577 16.9311 31.9095 16.9311H33.0212V17.7193H35.2129V16.9311H36.3251C37.6179 16.9311 38.5994 16.5494 39.2706 15.838ZM35.9004 10.4781C37.2579 10.4781 37.9942 11.4063 37.9942 12.8446C37.9942 14.4165 37.2416 15.3181 35.7365 15.3181H35.2129V10.4781H35.9004ZM33.0212 10.4781V15.3181H32.4976C30.9929 15.3181 30.2407 14.4165 30.2407 12.8446C30.2407 11.3733 30.9769 10.4781 32.334 10.4781H33.0212Z"
    }), _jsx(PathText, {
      d: "M46.7557 16.9366H48.9441V8.84847H46.7557L43.4386 13.7006V8.84847H41.2499V16.9366H43.4386L46.7557 12.1027V16.9366Z"
    }), _jsx(PathText, {
      d: "M58.2086 16.9366H56.0196V13.7006H52.7038V16.9366H50.5154V8.84849H52.7038V12.1028H56.0196V8.84849H58.2086V16.9366Z"
    }), _jsx(PathText, {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M62.5217 16.9366H67.4551V12.4192C67.4551 10.8829 67.0795 9.81577 66.3115 9.2871C65.9033 9.00646 65.2798 8.84336 64.4312 8.84336H60.068L60.0691 10.4767H63.7405C64.966 10.4767 65.429 10.9002 65.429 11.9081V12.1115H62.4237C61.4592 12.1115 60.741 12.3042 60.2676 12.7993C59.8592 13.2289 59.6058 13.7822 59.6058 14.5254C59.6058 15.3682 59.9244 16.0208 60.4631 16.4165C60.9374 16.7633 61.6222 16.9366 62.5217 16.9366ZM65.429 15.326V13.7102H62.5385C61.9494 13.7102 61.558 13.8878 61.558 14.5317C61.558 15.1264 61.9989 15.326 62.5385 15.326H65.429Z"
    }), _jsx(PathText, {
      d: "M75.4817 10.1084C75.7435 9.29981 76.2663 8.85322 77.1151 8.85322L79.1177 8.85783V16.9373H76.9296V11.2414L75.0707 16.9373H72.9924L71.1334 11.2414V16.9329H68.9463V8.85783L70.949 8.85322C71.798 8.85322 72.3207 9.29981 72.5816 10.1084L74.0316 14.5186L75.4817 10.1084Z"
    }), _jsx("path", {
      d: "M3.44366 18.0749L4.62854 19.0138L5.81379 19.9509C5.81379 19.9509 6.0114 19.2364 6.50858 18.2975L4.13883 16.4211C3.64202 17.3604 3.44366 18.0749 3.44366 18.0749Z",
      fill: "#C86400"
    }), _jsx("path", {
      d: "M4.28911 16.1483L6.65886 18.0246C6.91623 17.5719 7.24122 17.0804 7.6424 16.5984L5.27339 14.7224C4.87146 15.204 4.54723 15.6952 4.28911 16.1483Z",
      fill: "#D28214"
    }), _jsx("path", {
      d: "M5.47545 14.4908L7.84371 16.3667C8.21576 15.9517 8.64757 15.5503 9.14551 15.1938L6.7765 13.3171C6.27782 13.6744 5.84526 14.0746 5.47545 14.4908Z",
      fill: "#D29628"
    }), _jsx("path", {
      d: "M14.7431 8.85195L17.1121 10.7275C17.5091 10.3478 17.8999 9.92555 18.2809 9.44772L15.9111 7.57178C15.5305 8.04847 15.139 8.4719 14.7431 8.85195Z",
      fill: "#F5D246"
    }), _jsx("path", {
      d: "M9.08313 12.1571L11.4525 14.0323C12.0192 13.8048 12.6329 13.5621 13.2732 13.2691L10.9034 11.3936C10.2632 11.6857 9.64979 11.9285 9.08313 12.1571Z",
      fill: "#FADE6E"
    }), _jsx("path", {
      d: "M7.24374 13.0084C7.17538 13.0507 7.10889 13.094 7.04128 13.1367L9.41178 15.0134C9.47827 14.9704 9.54476 14.9259 9.61312 14.8855C10.0461 14.6234 10.5582 14.3982 11.1263 14.1646L8.75696 12.2898C8.18917 12.5219 7.6763 12.7471 7.24374 13.0084Z",
      fill: "#FAAA00"
    }), _jsx("path", {
      d: "M18.1459 3.75797L20.5149 5.63392C20.7416 5.10701 20.9579 4.54358 21.1626 3.94211L18.7929 2.06616C18.5878 2.66802 18.3719 3.23107 18.1459 3.75797Z",
      fill: "#E39205"
    }), _jsx("path", {
      d: "M17.2218 5.6236L19.592 7.49879C19.8684 7.01411 20.134 6.49176 20.3876 5.92415L18.0193 4.04858C17.7642 4.6162 17.4979 5.13816 17.2218 5.6236Z",
      fill: "#E5A40A"
    }), _jsx("path", {
      d: "M11.2134 11.2488L13.5832 13.1255C14.1173 12.8691 14.6676 12.5727 15.2211 12.2174L12.8521 10.3403C12.2986 10.696 11.7483 10.992 11.2134 11.2488Z",
      fill: "#FFFABA"
    }), _jsx("path", {
      d: "M13.121 10.1625L15.49 12.0388C15.9562 11.7223 16.4239 11.3593 16.8852 10.9382L14.5162 9.06299C14.0549 9.48261 13.5876 9.84593 13.121 10.1625Z",
      fill: "#FFDC7D"
    }), _jsx("path", {
      d: "M16.0997 7.33029L18.4694 9.20585C18.8015 8.77025 19.1258 8.29241 19.4365 7.76703L17.0668 5.89185C16.7553 6.41609 16.4318 6.89468 16.0997 7.33029Z",
      fill: "#EBB000"
    }), _jsx("path", {
      d: "M0 15.349L1.18488 16.2861L2.36901 17.2246C2.36901 17.2246 2.56586 16.5105 3.06454 15.5693L0.695536 13.6934C0.19611 14.6349 0 15.349 0 15.349Z",
      fill: "#880012"
    }), _jsx("path", {
      d: "M0.844513 13.4215L3.21427 15.2974C3.47164 14.8451 3.79662 14.3536 4.19781 13.8719L1.8288 11.9956C1.42687 12.4776 1.10188 12.9691 0.844513 13.4215Z",
      fill: "#B40A1E"
    }), _jsx("path", {
      d: "M2.02911 11.7645L4.39887 13.6401C4.77054 13.2246 5.20311 12.8236 5.70179 12.4668L3.33203 10.5901C2.83335 10.9473 2.40079 11.3475 2.02911 11.7645Z",
      fill: "#BB001E"
    }), _jsx("path", {
      d: "M11.2982 6.12463L13.6684 7.99981C14.0654 7.6209 14.4558 7.19861 14.8368 6.72154L12.467 4.84521C12.086 5.3219 11.6946 5.74533 11.2982 6.12463Z",
      fill: "#D93636"
    }), _jsx("path", {
      d: "M5.63818 9.42964L8.00831 11.3052C8.57423 11.0777 9.18871 10.8354 9.82859 10.5424L7.45883 8.66724C6.81783 8.96017 6.20485 9.20213 5.63818 9.42964Z",
      fill: "#FC8D8D"
    }), _jsx("path", {
      d: "M3.79936 10.2815C3.73063 10.323 3.66451 10.3664 3.59802 10.4101L5.96778 12.2864C6.03352 12.2435 6.10001 12.1993 6.16912 12.1582C6.60093 11.8969 7.11381 11.6713 7.68122 11.4377L5.31146 9.5625C4.7448 9.79533 4.2323 10.0217 3.79936 10.2815Z",
      fill: "#E60000"
    }), _jsx("path", {
      d: "M13.7782 2.89652L16.1479 4.7717C16.4232 4.28703 16.6888 3.76468 16.9432 3.19745L14.5738 1.32227C14.3206 1.88874 14.0539 2.41146 13.7782 2.89652Z",
      fill: "#BC001D"
    }), _jsx("path", {
      d: "M7.76898 8.52139L10.1376 10.3977C10.6736 10.1413 11.2224 9.8457 11.7767 9.48961L9.40697 7.61328C8.853 7.96861 8.30389 8.26535 7.76898 8.52139Z",
      fill: "#FFCECE"
    }), _jsx("path", {
      d: "M9.67618 7.43541L12.0459 9.31211C12.5129 8.99482 12.9798 8.63227 13.4411 8.21188L11.0721 6.33594C10.6108 6.75632 10.1431 7.11964 9.67618 7.43541Z",
      fill: "#EB8998"
    }), _jsx("path", {
      d: "M12.6553 4.60285L15.0243 6.4788C15.3567 6.04358 15.6795 5.56498 15.9918 5.04036L13.6235 3.16479C13.3097 3.68942 12.987 4.16763 12.6553 4.60285Z",
      fill: "#CB0013"
    }), _jsx("path", {
      d: "M6.88924 20.8024L8.07299 21.7398L9.25862 22.6779C9.25862 22.6779 9.45436 21.9642 9.95266 21.0245L7.58365 19.1475C7.08535 20.0883 6.88924 20.8024 6.88924 20.8024Z",
      fill: "#880012"
    }), _jsx("path", {
      d: "M7.73352 18.8761L10.1036 20.7509C10.3606 20.2986 10.6853 19.807 11.0872 19.3262L8.7178 17.4495C8.31513 17.9319 7.99164 18.423 7.73352 18.8761Z",
      fill: "#B40A1E"
    }), _jsx("path", {
      d: "M8.9187 17.2179L11.2877 19.0942C11.6601 18.6788 12.0919 18.2774 12.5906 17.921L10.2212 16.0454C9.72219 16.4011 9.29075 16.8021 8.9187 17.2179Z",
      fill: "#BB001E"
    }), _jsx("path", {
      d: "M18.1874 11.5782L20.5564 13.4542C20.9535 13.0749 21.3442 12.653 21.7249 12.1752L19.3562 10.2988C18.976 10.7755 18.5845 11.1993 18.1874 11.5782Z",
      fill: "#D93636"
    }), _jsx("path", {
      d: "M12.5279 14.8845L14.8969 16.7593C15.4628 16.5311 16.0773 16.2899 16.7183 15.9962L14.3493 14.1206C13.7075 14.4139 13.0942 14.6559 12.5279 14.8845Z",
      fill: "#FC8D8D"
    }), _jsx("path", {
      d: "M10.6887 15.7353C10.6199 15.7779 10.5531 15.822 10.4873 15.8638L12.8556 17.7394C12.9228 17.6964 12.9889 17.653 13.0584 17.6123C13.4902 17.3506 14.0031 17.125 14.5705 16.8918L12.2015 15.0166C11.6341 15.2502 11.1208 15.4754 10.6887 15.7353Z",
      fill: "#E60000"
    }), _jsx("path", {
      d: "M14.6585 13.9754L17.0275 15.8517C17.5624 15.5949 18.1119 15.2993 18.6659 14.9436L16.2954 13.0676C15.7429 13.4237 15.1916 13.7197 14.6585 13.9754Z",
      fill: "#FFCECE"
    }), _jsx("path", {
      d: "M16.5652 12.8902L18.9349 14.7657C19.4019 14.4492 19.8684 14.0866 20.3301 13.6651L17.9611 11.7896C17.5002 12.2096 17.0325 12.5729 16.5652 12.8902Z",
      fill: "#EB8998"
    }), _jsx("path", {
      d: "M19.5449 10.0571L21.9139 11.933C22.246 11.4974 22.5688 11.0192 22.881 10.4938L20.5113 8.61865C20.1997 9.14366 19.8766 9.62073 19.5449 10.0571Z",
      fill: "#CB0013"
    })]
  }));
};

export default FinamIcon;